export enum FilterFreeTextKeys {
    COMMENT = 'comment',
    AUTHOR = 'author',
}

export const TABLE_ID_VULNERABILITY_EXCLUSION = 'vulnerability-exclusion';
